import { AdminRouter, AdminSidebar } from '../stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'
import { VIEW_DRIVERS_SCHEDULE } from '../constants/permissions'

const base = 'drivers'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.schedule`,
  path: `/${base}/schedule`,
  component: () => import('./DriversSchedule.vue'),
  meta: {
    auth: true,
    // newLayout: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.create`,
  path: `/${base}/create`,
  component: () => import('./Create.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.edit`,
  path: `/${base}/:id`,
  component: () => import('./Edit.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItems([
  {
    id: `${base}`,
    order: 30,
    header: ($vm) => $vm.$t(`general.menu_management`),
    text($vm) {
      return $vm.$t(`${base}.title`)
    },
    route: {
      name: `${base}`,
    },
    icon: 'icon-vcard',
    permission($vm) {
      return $vm.$allows('drivers.index') || $vm.$allows('drivers.serve')
    },
  },
  {
    id: `${base}.schedule`,
    order: 31,
    header: ($vm) => $vm.$t(`general.menu_management`),
    text($vm) {
      return $vm.$t(`${base}.schedule`)
    },
    route: {
      name: `${base}.schedule`,
    },
    icon: 'icon-calendar',
    permission($vm) {
      return $vm.$allows(VIEW_DRIVERS_SCHEDULE)
    },
  },
])

messageGroups.push(base)
